// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer--2r1wV","noLabel":"noLabel--3E8om","descriptions":"descriptions--1u-Yv"};